import { useQuery } from "@tanstack/react-query";
import { Row, Col, Input, Typography } from "antd";
import { Fragment } from "react/jsx-runtime";
import {
  Controller,
  FieldErrors,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { journalsQueries } from "@/entities/journal";
import { generateConstructionTypeName } from "@/entities/object";
import { TableInfoType } from "@/features/table-info";
import { Can } from "@/shared/lib/casl";
import { useCoordinator } from "@/shared/lib/hooks";
import { fallbackString } from "@/shared/utils";
import { useTitleAmendmentMode } from "../../../../model";

interface IJournalsInfoTable {
  errors: FieldErrors<{
    journalnumber: string;
  }>;
}

export const JournalsInfoMain = ({ errors }: IJournalsInfoTable) => {
  const { control } = useFormContext();
  const { titleId } = useCoordinator();
  const { data } = useQuery(journalsQueries.getTitleJournal({ titleId }));

  const journalNumberValue = useWatch({
    control,
    name: "journalnumber",
  });

  const titleStatus =
    data?.mainJournal?.titleJournal?.status === "NEW" &&
    // @ts-expect-error versionNumber отсутствует в openapi типе TitleJournalViewDto
    !data?.mainJournal?.titleJournal?.versionNumber;
  const { isNewAmendment } = useTitleAmendmentMode();
  const canEditJournalNumber =
    titleStatus ||
    (isNewAmendment && !data?.mainJournal?.titleJournal?.mainJournalNumber);

  const journalInfo: TableInfoType[] = [
    {
      id: 1,
      title: "Вид строительства",
      info: fallbackString(
        generateConstructionTypeName(
          data?.mainJournal?.buildingObject?.constructionType as string,
        ),
      ) as string,
    },
    {
      id: 2,
      title: "Наименование объекта капитального строительства",
      info: fallbackString(
        data?.mainJournal?.buildingObject?.fullName,
      ) as string,
    },
    {
      id: 3,
      title: "Строительный адрес объекта",
      info: fallbackString(
        data?.mainJournal?.buildingObject?.address?.addressString,
      ) as string,
    },
  ];
  return (
    <Row gutter={[16, 16]}>
      <Col span={8} style={{ color: "#666666" }}>
        Номер журнала
      </Col>
      <Col span={16}>
        <Can I="edit" a="title_journals">
          <Controller
            name="journalnumber"
            control={control}
            render={({ field }) => (
              <div className="journal-title-journal-number-field">
                <Input
                  style={{ maxWidth: "104px" }}
                  {...field}
                  disabled={!canEditJournalNumber}
                />
                {errors.journalnumber && (
                  <Typography.Text style={{ color: "red" }}>
                    {errors.journalnumber.message}
                  </Typography.Text>
                )}
              </div>
            )}
          />
        </Can>
        <Can not I="edit" a="title_journals">
          <div>{journalNumberValue}</div>
        </Can>
      </Col>
      {journalInfo.map((item) => (
        <Fragment key={item.id}>
          <Col span={8} style={{ color: "rgba(119, 119, 119, 1)" }}>
            {item.title}
          </Col>
          <Col span={16} style={{ color: "rgba(51, 51, 51, 1)" }}>
            {item.info}
          </Col>
        </Fragment>
      ))}
    </Row>
  );
};
